/* Helper Functions */

export function getUrlParameterByName(name, url = window.location.href) {
    //name = name.replace(/[\[\]]/g, '\\$&');
    name = name.replace(/[[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function decodeUrlHashString(hash) {
    if (!hash) return "";
    try {
        return JSON.parse(atob(hash));
    } catch (e) {
        console.error("Failed to decode hash:", e);
        return null;
    }
}

export function generateId(length) {
    let result = '';
    let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

/* User Status Constants */
export const USER_STATUS = {
    ACTIVE: 1,
    OOO: 2,
    DISABLED: 0,
    HOTEL_DISABLED: -1,
    DISABLED_BY_ADMIN: -2,
};

/**
 * Check if user status indicates the user is disabled
 * @param {number} status - User status value
 * @returns {boolean} - True if user is disabled
 */
export function isUserDisabled(status) {
    return status !== undefined && status <= 0;
}

/**
 * Get error message for disabled user status
 * @param {number} status - User status value
 * @returns {string} - Error message for the given status
 */
export function getDisabledUserMessage(status) {
    switch (status) {
        case USER_STATUS.HOTEL_DISABLED:
            return "Your org has been disabled. Please reach out to Admin/Vesta to enable";
        case USER_STATUS.DISABLED_BY_ADMIN:
            return "Your account has been disabled by the admin";
        case USER_STATUS.DISABLED:
        default:
            return "Your account has been disabled. Please contact Admin.";
    }
}

/**
 * Check if user is disabled and return error message if so
 * @param {object} user - User object with status property
 * @returns {{isDisabled: boolean, message: string}} - Disabled status and message
 */
export function checkUserDisabledStatus(user) {
    if (user && isUserDisabled(user.status)) {
        return {
            isDisabled: true,
            message: getDisabledUserMessage(user.status)
        };
    }
    return {
        isDisabled: false,
        message: null
    };
}